import { render, staticRenderFns } from "./ChitchatContents.vue?vue&type=template&id=829b3e1e&scoped=true&"
import script from "./ChitchatContents.vue?vue&type=script&lang=js&"
export * from "./ChitchatContents.vue?vue&type=script&lang=js&"
import style0 from "./ChitchatContents.vue?vue&type=style&index=0&id=829b3e1e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829b3e1e",
  null
  
)

export default component.exports